export enum ReasonInputType {
  Text = 'text',
  Checkbox = 'checkbox',
  Select = 'select',
  CheckboxList = 'checkbox-list',
  RichText = 'rich-text',
}
